import { InjectionToken } from '@angular/core';
import type { AppContext } from './app-context.types';

export const APP_CONTEXT: InjectionToken<AppContext> = new InjectionToken<AppContext>('APP_CONTEXT');
